import React from 'react';
import { Box, Paper } from '@mui/material';

import {
  DETAIL_PANEL_MIN_TABLE_VIEWPORT_HEIGHT,
  getDetailPanelTableBodySx,
  getDetailPanelTableSectionSx,
} from '../utils/detailPanelTableLayout';

// Shared drawer wrapper for table-heavy sections. The drawer keeps the outer
// vertical scroll, while the embedded MRT grid keeps its own row/column overflow
// inside a section with a stable minimum viewport floor.
const DetailPanelScrollableTableSection = ({
  children,
  header = null,
  minHeight = DETAIL_PANEL_MIN_TABLE_VIEWPORT_HEIGHT,
  sectionSx = null,
  bodySx = null,
  'data-testid': testId,
}) => (
  <Paper
    data-testid={testId}
    elevation={2}
    sx={{
      ...getDetailPanelTableSectionSx(minHeight),
      ...(sectionSx || {}),
    }}
  >
    {header}
    <Box
      sx={{
        ...getDetailPanelTableBodySx(minHeight),
        ...(bodySx || {}),
      }}
    >
      {children}
    </Box>
  </Paper>
);

export default DetailPanelScrollableTableSection;
